import { iconText, iconUpload, iconUploadAndText } from '@/components/icons';

import {
  PersonalisationFlow,
  PersonalisationStep,
  PersonalisationStepId,
  PersonalisationType,
  PersonalisationTypeOptions,
} from '@/types';

export const TYPE_OPTIONS: PersonalisationTypeOptions = [
  {
    icon: iconUpload,
    titleTranslationKey: 'content.personalisation.chooseTypeStep.fileTitle',
    descriptionTranslationKey:
      'content.personalisation.chooseTypeStep.fileDescription',
    type: PersonalisationType.LOGO,
  },
  {
    icon: iconUploadAndText,
    titleTranslationKey:
      'content.personalisation.chooseTypeStep.fileAndTextTitle',
    descriptionTranslationKey:
      'content.personalisation.chooseTypeStep.fileAndTextDescription',
    type: PersonalisationType.LOGO_TEXT,
  },
  {
    icon: iconText,
    titleTranslationKey: 'content.personalisation.chooseTypeStep.onlyTextTitle',
    descriptionTranslationKey:
      'content.personalisation.chooseTypeStep.onlyTextDescription',
    type: PersonalisationType.TEXT,
  },
];

export const STEP_TYPE: PersonalisationStep = {
  id: PersonalisationStepId.TYPE,
  titleTranslationKey: 'content.personalisation.chooseTypeStep.title',
};
export const STEP_UPLOAD_SELECT_FILE: PersonalisationStep = {
  id: PersonalisationStepId.UPLOAD_SELECT_FILE,
  titleTranslationKey: 'content.personalisation.uploadFileStep.title',
};
export const STEP_UPLOAD_PROCESS: PersonalisationStep = {
  id: PersonalisationStepId.UPLOAD_PROCESS,
  titleTranslationKey: 'content.personalisation.uploadFileStep.title',
};
export const STEP_COLORS_SOURCE: PersonalisationStep = {
  id: PersonalisationStepId.COLORS_SOURCE,
  titleTranslationKey: 'content.personalisation.chooseColorsStep.title',
};
export const STEP_PICK_COLORS: PersonalisationStep = {
  id: PersonalisationStepId.PICK_COLORS,
  titleTranslationKey: 'content.personalisation.chooseColorsStep.title',
};
export const STEP_PICK_COLORS_WITH_FILE: PersonalisationStep = {
  id: PersonalisationStepId.PICK_COLORS_WITH_FILE,
  titleTranslationKey: 'content.personalisation.chooseColorsStep.title',
};
export const STEP_TEXT: PersonalisationStep = {
  id: PersonalisationStepId.TEXT,
  titleTranslationKey: 'content.personalisation.textStep.title',
};
export const STEP_TEXT_WIHT_FILE: PersonalisationStep = {
  id: PersonalisationStepId.TEXT_WITH_FILE,
  titleTranslationKey: 'content.personalisation.textStep.title',
};
export const STEP_DONE: PersonalisationStep = {
  id: PersonalisationStepId.DONE,
  titleTranslationKey: 'content.personalisation.doneStep.title',
};

export const FLOW_LOGO: PersonalisationFlow = [
  STEP_TYPE,
  STEP_UPLOAD_SELECT_FILE,
  STEP_UPLOAD_PROCESS,
  STEP_COLORS_SOURCE,
  STEP_PICK_COLORS_WITH_FILE,
  STEP_DONE,
];

export const FLOW_LOGO_TEXT: PersonalisationFlow = [
  STEP_TYPE,
  STEP_UPLOAD_SELECT_FILE,
  STEP_UPLOAD_PROCESS,
  STEP_COLORS_SOURCE,
  STEP_PICK_COLORS_WITH_FILE,
  STEP_TEXT_WIHT_FILE,
  STEP_DONE,
];

export const FLOW_TEXT: PersonalisationFlow = [
  STEP_TYPE,
  STEP_TEXT,
  STEP_PICK_COLORS,
  STEP_DONE,
];

export const FLOW_LOGO_FULL_COLOR: PersonalisationFlow = [
  STEP_TYPE,
  STEP_UPLOAD_SELECT_FILE,
  STEP_UPLOAD_PROCESS,
  STEP_DONE,
];

export const FLOW_LOGO_TEXT_FULL_COLOR: PersonalisationFlow = [
  STEP_TYPE,
  STEP_UPLOAD_SELECT_FILE,
  STEP_UPLOAD_PROCESS,
  STEP_TEXT_WIHT_FILE,
  STEP_DONE,
];

export const FLOW_TEXT_FULL_COLOR: PersonalisationFlow = [
  STEP_TYPE,
  STEP_TEXT,
  STEP_DONE,
];
